// removed by extract-text-webpack-plugin
module.exports = {"emojiInput":"_1LKsDGYBlMOJLODvqmWJaU","emojiButton":"_15OmQ4j0bNYptGCPeIOOuG","active":"_1V07pgdnJUr0a7O2kgXrI-","editor":"pj8A90Jf_zttcrAOYV6bK"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-96ed060a","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"sourceMap":true}!./~/vue-components/emoji-input/emoji-input.less
// module id = kj1R
// module chunks = 1